import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { InlineAlertTypes } from '@app/shared/types/inline-alert-types';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-inline-alert',
    imports: [
        CommonModule,
        TranslateModule,
        RouterLink
    ],
    templateUrl: './inline-alert.component.html',
    styleUrls: ['./inline-alert.component.scss']
})
export class InlineAlertComponent implements OnInit {
  @Input() type: InlineAlertTypes;
  @Input() text: string;
  @Input() link: string;
  @Input() linkText: string;


  inlineAlertTypes = InlineAlertTypes;

  constructor() {
    }

  ngOnInit() {
  }

}
